import { useState, useRef, useEffect } from "react";
import { FiInfo } from "react-icons/fi";

const FeeBreakdown = ({ platformFee }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useRef(null); // Ref for the tooltip

  // Handle hover for desktop
  const handleMouseEnter = () => {
    if (window.innerWidth > 640) {
      // sm breakpoint
      setIsTooltipVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 640) {
      setIsTooltipVisible(false);
    }
  };

  // Handle click for mobile
  const handleClick = () => {
    if (window.innerWidth <= 640) {
      setIsTooltipVisible(!isTooltipVisible);
    }
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target) && isTooltipVisible) {
        setIsTooltipVisible(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTooltipVisible]);

  return (
    <div className="relative">
      <p className="flex justify-between items-center">
        <span className="flex items-center gap-2">
          Platform Fee :
          <button
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label="Platform Fee Info"
          >
            <FiInfo className="w-4 h-4" />
          </button>
        </span>
        <span>₹{(platformFee ?? 0).toFixed(2)}</span>
      </p>

      {/* Tooltip/Popover */}
      {isTooltipVisible && (
        <div
          ref={tooltipRef}
          className="absolute left-0 mt-2 p-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg text-sm w-64 z-50"
        >
          <p className="text-gray-700 dark:text-gray-300 font-semibold mb-2">
            Platform Fee Calculation:
          </p>
          <ul className="space-y-2">
            <li className="flex justify-between">
              <span>Gateway Charge:</span>
              <span className="font-medium">2.5%</span>
            </li>
            <li className="flex justify-between">
              <span>Service Charge:</span>
              <span className="font-medium">1.5%</span>
            </li>
            <li className="flex justify-between">
              <span>Processing Fee:</span>
              <span className="font-medium">1.0%</span>
            </li>
          </ul>
          <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
            <p className="flex justify-between text-gray-700 dark:text-gray-300">
              <span>Total Percentage:</span>
              <span className="font-semibold">5.0%</span>
            </p>
            <p className="flex justify-between text-gray-700 dark:text-gray-300 mt-1">
              <span>Minimum Fee:</span>
              <span className="font-semibold">₹2.00</span>
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
              You pay whichever is higher: 5% of subtotal or ₹2 minimum
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeeBreakdown;
